import { render, staticRenderFns } from "./TrainingDetail.vue?vue&type=template&id=953a9048"
import script from "./TrainingDetail.vue?vue&type=script&lang=js"
export * from "./TrainingDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3029718028/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('953a9048')) {
      api.createRecord('953a9048', component.options)
    } else {
      api.reload('953a9048', component.options)
    }
    module.hot.accept("./TrainingDetail.vue?vue&type=template&id=953a9048", function () {
      api.rerender('953a9048', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/lifehikes/training/components/TrainingDetail.vue"
export default component.exports